
import { Component, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { combineLatest, switchMap, take } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { OrganizationService } from '../../services/organization.service';
import { OrganizationData } from '../../shared/models/organization-data.model';
import { FormAppComponent } from '../form-app/form-app.component';
import { AppFormMode } from '../form-app/models/app-form';
import { FormAppService } from '../form-app/services/form-app.service';

@Component({
    selector: 'app-create-app',
    imports: [FormAppComponent, MatButtonModule, MatProgressSpinnerModule],
    templateUrl: './create-app.component.html',
    styleUrl: './create-app.component.scss',
    providers: [FormAppService]
})
export class CreateAppComponent {
    public organization: OrganizationData;
    public loading: boolean = true;
    public saving: boolean = false;
    public disabledFields: string[] = ['organizationName'];
    public AppFormMode = AppFormMode;
    public id: string;

    @ViewChild('form') formElement: FormAppComponent;

    constructor(
        private readonly organizationService: OrganizationService,
        private readonly authService: AuthService,
        private readonly snackBar: MatSnackBar,
        private readonly router: Router
    ) {}

    public save(organizationData: OrganizationData): void {
        this.saving = true;

        combineLatest([this.authService.getAuthenticatedUserUid(), this.authService.getAuthenticatedUserRole()])
            .pipe(
                take(1),
                switchMap(([userUid, userRole]) =>
                    this.organizationService
                        .createOrganization({
                            ...organizationData,
                            userId: userUid,
                            userProfile: userRole,
                        })
                        .pipe(take(1))
                )
            )
            .subscribe({
                next: () => {
                    this.snackBar.open('Organization created. Generating App...', 'Close', {
                        duration: 3000,
                    });
                    this.goToDashboard();
                },
                error: () => {
                    this.saving = false;
                    this.loading = false;
                    this.snackBar.open('An error occurred. Check the console.', 'Close', {
                        duration: 5000,
                    });
                },
                complete: () => {
                    this.saving = false;
                    this.loading = false;
                },
            });
    }

    public goToDashboard(): void {
        this.router.navigate(['/dashboard']);
    }
}
